import React from 'react';
import './HeroSection.css';
import { FaWifi, FaParking, FaStar, FaRegClock, FaSnowflake, FaToilet, FaLock, FaBed, FaBolt, FaConciergeBell } from 'react-icons/fa';

const images = [
  '/images/1.jpeg',
  '/images/2.jpeg',
  '/images/3.jpeg',
  '/images/4.jpeg',
  '/images/5.jpeg',
  '/images/6.jpeg',
];

export default function HeroSection({ onBookNow }) {
  return (
    <section className="hero-section">
      <div className="hero-inner">
        <div className="hero-content">
          <span className="hero-badge">For Every Kind of Traveler</span>
          <h1 className="hero-title">Comfortable Stays in the <br /> Heart of Hyderabad</h1>
          <p className="hero-desc">
            Stay social, sleep comfy, and meet awesome travelers at Skyline Backpackers in Sindhi Colony. Clean beds and a lively vibe.
          </p>
          <div className="hero-card">
  <div className="hero-card-row">
        <span className="hero-rating">
      <FaStar className="star-icon" /> 4.8 <span className="hero-reviews">(124 reviews)</span>
    </span>
  </div>
  <div className="hero-amenities-grid">
    <div className="hero-amenity"><FaWifi className="amenity-icon" /> Free WiFi</div>
    <div className="hero-amenity"><FaParking className="amenity-icon" /> Parking</div>
    <div className="hero-amenity"><FaSnowflake className="amenity-icon" /> Centralised AC</div>
    <div className="hero-amenity"><FaRegClock className="amenity-icon" /> 24/7 Support</div>
    <div className="hero-amenity"><FaToilet className="amenity-icon" /> Clean Washrooms</div>
    <div className="hero-amenity"><FaLock className="amenity-icon" /> Lockers</div>
    <div className="hero-amenity"><FaBed className="amenity-icon" /> Cozy Beds</div>
    <div className="hero-amenity"><FaBolt className="amenity-icon" /> Personal Charging Point</div>
    <div className="hero-amenity"><FaConciergeBell className="amenity-icon" /> Guest Reception</div>
  </div>
  <button className="hero-btn" onClick={onBookNow}>Book Your Bed Now</button>
</div>
          <div className="hero-location">
            <span>📍 Sindhi Colony, Hyderabad, Telangana 500003</span>
          </div>
        </div>
        <div className="hero-images">
          {images.map((src, idx) => (
            <div key={idx} className="hero-image-card">
              <img src={src} alt={`Hostel preview ${idx + 1}`} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
